import { Component } from '@angular/core';

@Component({
  selector: 'app-base-route',
  templateUrl: './base-route.component.html',
  styleUrl: './base-route.component.scss',
})
export class BaseRouteComponent {}
